<template>
  <div></div>
</template>

<script>
import axios from 'axios';
import {ebus} from "@/vendor/ebus";
import {getErrorDetails} from "@/util/globalErrorHandler";

const API_KEY = 'AIzaSyD--hIop8fTpEdcJ-U530XQlxSGPPS08F0';

export default {
  name: "GoogleGeopositionTool",
  created() {
    ebus.$on('getGeoposition', (params) => {
      this.getGeoposition(params.address, params.cbAddress);
    });
  },
  methods: {
    replaceDashesWithSpaces(str) {
      return str.replace(/-/g, ' ');
    },

    async geocode(address) {
      if (!address) {
        throw new Error("Fehlende Parameter: address und apiKey sind erforderlich.");
      }

      const encodedAddress = encodeURIComponent(address);
      let _url = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodedAddress}&result_type=street_address|premise&key=`;
      const url = _url + API_KEY;

      console.log('geoposition going to send google api request ' + url);

      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`HTTP Fehler: ${response.status}`);
      }

      const data = await response.json();

      if (data.status !== "OK" || !data.results || data.results.length === 0) {
        console.warn("Keine passenden Ergebnisse gefunden:", data.status);
        return null;
      }

      const best = data.results[0];
      const {lat, lng} = best.geometry.location;
      const locType = best.geometry.location_type;

      // einfache Relevanzbewertung basierend auf location_type
      const relevanceMap = {
        ROOFTOP: 1.0,
        RANGE_INTERPOLATED: 0.8,
        GEOMETRIC_CENTER: 0.6,
        APPROXIMATE: 0.4,
      };

      const relevance = relevanceMap[locType] || 0.5;

      return {
        lat,
        lng,
        relevance,
        locationType: locType,
        formattedAddress: best.formatted_address,
      };
    },

    async getGeoposition(address, cbAddress) {
      console.log('getGeoposition for address: ', JSON.stringify(address, null, 2));
      let street = '';
      let plz = ''
      let city = '';
      try {
        street = this.replaceDashesWithSpaces(address.street);
        plz = this.replaceDashesWithSpaces(address.plz);
        city = this.replaceDashesWithSpaces(address.city);
      } catch (error) {
        ebus.$emit('toast', 'Invalid delivery area address');
      }
      let search = `${street}, ${plz} ${city}`;

      let geocodeResult = await this.geocode(search);

      console.log("geoposition geocodeResult:" + JSON.stringify(geocodeResult, null, 2));

      if (geocodeResult && geocodeResult.lat && geocodeResult.relevance) {
        try {
          //check relevance
          if (geocodeResult.relevance > 0.3) {
            this.reply(cbAddress, geocodeResult.lat, geocodeResult.lng);
          } else {
            this.reply(cbAddress);
          }

        } catch (e) {
          let eMsg = 'error parsing geoposition feature: ' + e.message;
          console.log(eMsg);
          ebus.$emit('throwError', getErrorDetails(e))
        }
      }
    },

    reply(cbAddress, lat, lng) {
      let r = {
        ok: !!(lat && lng)
      }
      if (r.ok) {
        r.geoPosition = {
          lat: lat,
          lng: lng
        }
      }
      console.log('geoposition final result: ' + JSON.stringify(r));
      ebus.$emit(cbAddress, r);
    },

  },
}
</script>

<style scoped>

</style>
